// SimpleButton.tsx
import React from 'react';
import s from './SimpleButton.module.css';

interface SimpleButtonProps {
    imageUrl: string;
    className?: string;
    width?: number;
    onClick: () => void;
    children?: React.ReactNode;
    disabled?: boolean;
}

const SimpleButton: React.FC<SimpleButtonProps> = ({ imageUrl, className, width, onClick, children, disabled }) => {

    const style: { [key: string]: any } = {
        backgroundImage: `url(${imageUrl})`
    };
    if (width) style['width'] = `${width}vw`;

    return (
        <button
            className={`${className ? className : ''} ${s.btn}`}
            onClick={onClick}
            style={style}
            type="button"
            disabled={disabled}
        >{children}</button>
    );
};

export default SimpleButton;
